import { defineMessages } from 'react-intl';

export default defineMessages({
  DeviationOverview: {
    id: 'DeviationOverview',
    defaultMessage: 'Matrix task schedules per relation',
  },
  Relation: {
    id: 'Relation',
    defaultMessage: 'Relation',
  },
  Assignment: {
    id: 'Assignment',
    defaultMessage: 'Assignment',
  },
  Totals: {
    id: 'Totals',
    defaultMessage: 'Totals',
  },
  SelectOverviewColumns: {
    id: 'DeviationOverviewSelectColumns',
    defaultMessage: 'Select columns',
  },
  ColumnConfig: {
    id: 'ColumnConfig',
    defaultMessage: 'Column config',
  },
  NoDataFound: {
    id: 'NoDataFound',
    defaultMessage: 'No data found',
  },
  WithoutSchedule: {
    id: 'WithoutSchedule',
    defaultMessage: 'Without schedule',
  },
  DrillDown: {
    id: 'DeviationOverviewDrillDown',
    defaultMessage: 'Show subtasks',
  },
  BackToOverview: {
    id: 'DeviationOverviewBackToOverview',
    defaultMessage: 'Back to overview',
  },
  AllMainTasks: {
    id: 'DeviationOverviewAllMainTasks',
    defaultMessage: 'All main tasks',
  },
  ResetFilters: {
    id: 'ResetFilters',
    defaultMessage: 'Reset filters',
  },
  ExportToExcel: {
    id: 'ExportToExcel',
    defaultMessage: 'Export to Excel',
  },
  ExportToExcelStarted: {
    id: 'ExportToExcelStarted',
    defaultMessage: 'Export to Excel started',
  },
});
